<script>
    export let imgURL;
    export let title;
    export let description;
    export let linkURL;
</script>

<div class="item-container">
    <div class="image-div elem">
        <img class="image-img" alt="item img" src={imgURL} >
    </div>
    <div class="main elem">
        <h1>{title}</h1>
        <p class="description">{description}</p>
    </div>
    <a class="link elem" href="{linkURL}">
        <span class="mdi mdi-earth"></span>
    </a>
</div>


<style lang="scss">
    @import '../global.scss';

    $bgColor: #313842;

    /* container style */
    .item-container {
        background-color: $bgColor;
        color: #FFF;
        font-size: 14px;
        font-family: sans-serif;
        display: table;
        margin: 2rem;
        width: 100%;
    }

    /* item elements common style */
    .elem {
        display: table-cell;
    }

    /* image */
	.image-div {
        width: 22%;
        vertical-align: middle;
	}
    .image-img {
        /* height: 15rem; */
        object-fit: contain;
        margin: 0;
        width: 100%;
    }

    /* title & description */
    .main {
        width: 70%;
        vertical-align: top;
    }
    h1 {
        font-size: 16px;
        font-weight: bold;
        color: #FFF;
        margin: 3rem 2rem 2rem 2rem;
    }
    p.description {
        margin: 2rem;

        /* show only 3 lines from description */
        overflow: hidden;
        display: -webkit-box !important;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: normal;
    }

    /* link */
    .link {
        width: 8%;
        // background-color: #ED6D3A;
        // color: #FFF1D9;
        font-size: 3rem;
        text-align: center;
        vertical-align: middle;
    }

    .link:hover {
        background-color: #fc4a00;
        font-size: 2.2rem;
    }

</style>